// ----------- Base screens layout -----------

export const LEFT_SIDEBAR_WIDTH_CSS = '20vw';
export const MINIMIZED_LEFT_SIDEBAR_WIDTH_CSS = '55px';
export const RIGHT_BLOCK_WIDTH_CSS = '80vw';
export const MINIMIZED_RIGHT_BLOCK_WIDTH_CSS = `calc(100vw - ${MINIMIZED_LEFT_SIDEBAR_WIDTH_CSS})`;
